import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import FirstRunOnboarding from '../components/FirstRunOnboarding';
import { useAuth } from '../context/AuthContext';

const REDIRECT_PATH = '/sistema/dashboard';

export default function Onboarding() {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();

  useEffect(() => {
    if (!loading && !profile?.organization_id) {
      navigate(REDIRECT_PATH, { replace: true });
    }
  }, [loading, navigate, profile?.organization_id]);

  if (loading || !profile?.organization_id) {
    return (
      <div className="min-h-screen bg-[var(--gst-cream-50)]">
        <div className="flex min-h-screen items-center justify-center px-4 py-8">
          <div className="flex flex-col items-center gap-4 rounded-[32px] border border-white/70 bg-[var(--surface)]/90 px-8 py-10 shadow-[0_30px_80px_rgba(15,23,42,0.12)] backdrop-blur-sm">
            <Loader2 className="animate-spin text-[var(--text-muted)]" size={30} />
            <div className="text-center">
              <p className="text-[11px] font-black uppercase tracking-[0.26em] text-[var(--text-muted)]">
                Preparando onboarding
              </p>
              <p className="mt-2 text-sm text-[var(--text-muted)]">
                Estamos validando la configuracion inicial de tu empresa.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <FirstRunOnboarding
      organizationId={profile.organization_id}
      userId={profile?.id || user?.id}
      userRole={profile?.role}
      userEmail={user?.email}
      onCompleted={async () => {
        try {
          sessionStorage.setItem('hasSeenStatus', 'true');
        } catch {
          // Si sessionStorage no esta disponible, el StatusGuard hara su flujo normal.
        }
        // Terminar el asistente inicial deja al usuario en "Empeza a operar",
        // que es el hub desde donde ELIGE que hacer.
        //
        // Antes se arrancaba el recorrido demo automaticamente y se caia en el
        // dashboard. El usuario terminaba una guia y, sin haber pedido nada, se
        // encontraba con otra encima: el paso 2 del demo le pide abrir
        // "Productos -> Catalogo", asi que parecia que el sistema le exigia
        // hacer una guia de producto en vez de dejarlo operar.
        //
        // El demo NO se elimina: sigue disponible cuando el usuario lo pida,
        // desde Ayuda -> tutorial interactivo y desde el menu de usuario
        // (handleRestartTutorial en TopbarMenu.jsx).
        navigate('/sistema/progreso', { replace: true });
      }}
      onUnavailable={() => {
        navigate(REDIRECT_PATH, { replace: true });
      }}
    />
  );
}
